import { z } from 'zod';

export const passwordSchema = z
  .string()
  .min(6, { message: "Senha deve ter no mínimo 6 caracteres" })
  .max(100, { message: "Senha muito longa" })
  .refine((password) => /[A-Z]/.test(password), {
    message: "Senha deve conter pelo menos 1 letra maiúscula",
  })
  .refine((password) => /[a-z]/.test(password), {
    message: "Senha deve conter pelo menos 1 letra minúscula",
  })
  .refine((password) => /[0-9]/.test(password), {
    message: "Senha deve conter pelo menos 1 número",
  });

export const changePasswordSchema = z.object({
  currentPassword: z.string().min(1, { message: "Senha atual é obrigatória" }),
  newPassword: passwordSchema,
  confirmPassword: z.string()
}).refine((data) => data.newPassword === data.confirmPassword, {
  message: "As senhas não coincidem",
  path: ["confirmPassword"],
});
